import {sellerConstants } from '../_constants';

const initialState = { loading : true, seller: '', error: false};

export function seller(state = initialState, action) {
    switch (action.type) {
      	case sellerConstants.REQUEST_SELLERS:
	        return {
        	  	loading: true,
	          	seller: '',
          		error: false
        	};
      	case sellerConstants.RECEIVE_SELLERS:
        	return {
          		loading: false,
          		seller: action.sellers,
          		error: false
        	};
      	case sellerConstants.SELLER_ERROR:
        	return { 
          		loading: false,
          		// error: action.error,
          		seller: '',
          		error: true
        	};
      	default:
        	return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/seller.reducer.js